export const userActionTypes = {
  SAVE_USER: "SAVE_USER",
  REMOVE_USER: "REMOVE_USER",
};
